import { Component } from '@angular/core';

@Component({
  selector: 'sh-new-typography',
  templateUrl: './new-typography.component.html',
  styleUrl: './new-typography.component.scss',
  standalone: false
})
export class NewTypographyComponent {}
